(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningDetailService', PlanningDetailService);

    PlanningDetailService.$inject = ['AutomaticEventService', 'PlanningEventsService','Planning', '$window','$cookies','$http', 'FileUploadService', '$uibModal', 'SoopkitchenUtils'];
    function PlanningDetailService (AutomaticEventService, PlanningEventsService, Planning, $window, $cookies, $http, FileUploadService, $uibModal, SoopkitchenUtils) {
        var vm = null;
        /** ** Constants *** */
        var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
        var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];
        var soopsGroup = 'SOOPs';

        return {
            submitNewEvCollection: submitNewEvCollection,
            submitNewObsDef : submitNewObsDef,
            soopify : soopify,
            unsoopify : unsoopify,
            openProfile : openProfile,
            updateDuration : updateDuration,
            applyWidth : applyWidth,
            applyPoints : applyPoints,
            updateLetters : updateLetters,
            durationLettersInvalid : durationLettersInvalid,
            panic : panic,
            bookMark : bookMark,
            saveBaseline : saveBaseline,
            updateEndDate : updateEndDate,
            setController: setController,
            getCookiePrefix: getCookiePrefix,
            invalidateDateRange  :  invalidateDateRange,
            unlock :  unlock,
            search :  search,
            openAutomaticEventWindow :  openAutomaticEventWindow,
            showAutomaticButton :  showAutomaticButton,
            canUpdateObsDef :  canUpdateObsDef,
            canUpdateParent :  canUpdateParent,
            canUpdateEvents :  canUpdateEvents,
            toggleCheckAll :  toggleCheckAll,
            resetWidth :  resetWidth,
            setValidityPeriod :  setValidityPeriod,
            resetZoomedDates :  resetZoomedDates,
            resetScroll: resetScroll,
            addVisItem: addVisItem,
            updateVisItem: updateVisItem,
            zoomIn :zoomIn,
            zoomOut :zoomOut,
            movePlanLeft :movePlanLeft,
            movePlanRight :movePlanRight,
            reload :reload,
            goBack :goBack,
            updateParent :updateParent,
            getPickerDate : getPickerDate,
            setPickerDate : setPickerDate,
            getPickerDate2 : getPickerDate2,
            setPickerDate2 : setPickerDate2,
            getPickerPoint1 : getPickerPoint1,
            getPickerPoint2 : getPickerPoint2,
            isEventGroup: isEventGroup,
            createTimeLine: createTimeLine
        };

        function setController(Controller) {
            vm = Controller;
        }

        function panic() {
            SoopkitchenUtils.panicConfirm('Lock Plan', 'Do you really want to lock plan ' + vm.planning.label + "?",
                function (ok) {
                    if (ok) {
                        SoopkitchenUtils.lockPlan(vm.planning.label, vm.planType, function () {
                            location.reload();
                        });
                    }
                });
        }

        function bookMark() {
            SoopkitchenUtils.bookmarkPrompt(function (inputValue) {
                if (inputValue === false)
                    return false;
                bookmarkPlan(inputValue);
            });
        }

        function bookmarkPlan(comment) {
            Planning.bookmark(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    comment: comment
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You saved plan " + vm.planning.label + " with the comment: " + comment, "success");
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function soopify() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/soopify.html',
                controller: 'SoopifyPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        labelToSoopify: vm.planning.label,
                        internalVersionToSoopify: vm.planning.internalVersion,
                    }
                }
            });
        }


        function unsoopify() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/unsoopify.html',
                controller: 'UnsoopifyPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        labelToUnsoopify: vm.planning.label,
                        internalVersionToUnsoopify: vm.planning.internalVersion,
                    }
                }
            });
        }

        function openProfile(group) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-profile.html',
                controller: 'PlanningProfileController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        group: group
                    }
                }
            });
        }

        function updateDuration() {
            if (false === SoopkitchenUtils.isValidDate(vm.getPickerDate2())) {
                vm.invalidateEndDate = true;
                return;
            } else {
                vm.invalidateEndDate = false;
            }
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }
        function applyWidth() {
            vm.timeline.setWindow(vm.getPickerDate(), vm.getPickerDate2(), {
                animation: true
            });
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }

        function applyPoints() {
            SoopkitchenUtils.prettyConfirm('Timeline fill in', 'Do you want to fill in timeline for the period '
                + vm.getPickerPoint1() + ' to ' + vm.getPickerPoint2() + '?',
                function (ok) {
                    if (ok) {
                        console.log("Start: ${vm.getPickerPoint1()} | End: ${vm.getPickerPoint2()}");
                        applyPointsSlewPlan(vm.getPickerPoint1(), vm.getPickerPoint2());
                    }
                });
        }

        function applyPointsSlewPlan(dateStart, dateEnd) {
            Planning.autoSlews(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    dateStart: dateStart,
                    dateEnd: dateEnd
                },
                function successCallback(response) {
                    SoopkitchenUtils.showPlanChanges(response, function () {
                        location.reload(); // Reloads page only when user clicks "OK"
                    });
                }, function errorCallback(response) {
                    console.log("Error - Start: ${dateStart} | End: ${dateEnd}");
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateLetters() {
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(vm.getPickerDate()).valueOf() + vm.duration * 1000);
            setPickerDate2(SoopkitchenUtils.formattedDate(newDate).substring(0, 10));
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }

        function durationLettersInvalid() {
            if (vm.durationLetters == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        }

        function submitNewEvCollection() {
            PlanningEventsService.updateEventCollection(
                {
                    planLabel: vm.planning.label,
                    eventCollectionsLabel: vm.selectedNewEventCollections
                },
                function successCallback() {
                    vm.changeEvCollecVisible = false;
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                })
        }

        function submitNewObsDef() {
            Planning.updateObsDef(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    obsDefLabel: vm.selectedNewObservationDefinitions
                },
                function successCallback() {
                    vm.changeObsDefVisible = false;
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )
        }

        function saveBaseline() {
            SoopkitchenUtils.saveBaselinePrompt(function (inputValue) {
                if (inputValue === false)
                    return false;
                saveBaseLineForPlan(inputValue);
            });
        }
        function updateEndDate() {
            if (false === SoopkitchenUtils.isValidDate(vm.getPickerDate())) {
                vm.invalidateStartDate = true;
                return;
            } else {
                vm.invalidateStartDate = false;
            }

            var newDate = new Date(Date.parse(vm.getPickerDate()).valueOf() + vm.duration * 1000);
            setPickerDate2(SoopkitchenUtils.formattedDate(newDate).substring(0, 10));
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }
        function saveBaseLineForPlan(comment) {
            Planning.baseline(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    comment: comment
                },
                function successCallback() {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You saved plan " + vm.planning.label + " with the comment: " + comment, "success");
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );

        }
        function getCookiePrefix() {
            return vm.planning.label + "_";
        }
        function invalidateDateRange() {
            var endDateMilliseconds = Date.parse(vm.getPickerDate2()).valueOf();
            var startDateMilliseconds = Date.parse(vm.getPickerDate()).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        }

        function unlock(label) {
            SoopkitchenUtils.unlockPrompt('Unlock Plan',
                "<img  height='102' width='102' src='content/images/unlock.png'/> <br>"
                + "Your about to unlock the plan " + label, function (ok) {
                    if (ok) {
                        SoopkitchenUtils.unlockPlan(label, vm.planType, function () {
                            location.reload();
                        });
                    }
                });
        }
        function openAutomaticEventWindow() {
            if (vm.status.hasOwnProperty('selectDates') === false || vm.status.selectDates === false) {
                vm.status.eventService(vm.planning.label);
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/planning/planning-automatic-event-dialog.html',
                    controller: 'PlanningAutomaticEventDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        entity: vm.planning,
                        parameters: {
                            id: vm.planning.label,
                            start: vm.dateRange[0],
                            end: vm.dateRange[1],
                            status: vm.status
                        }
                    }
                }).result.then(function () {
                }, function () {
                });
            }

        }

        function showAutomaticButton() {
            return vm.status !== AutomaticEventService.AUTOMATIC_EVENTS_STATUS.FINISHED;
        }

        function toggleCheckAll() {
            vm.checkedAll = vm.checkedAll === false;

            for (var group in vm.groups) {

                if (!isEventGroup(vm.groups[group])) {
                    vm.checkedValue[vm.groups[group]] = vm.checkedAll;
                    $cookies.put(getCookiePrefix() + "checkbox_" + vm.groups[group], vm.checkedAll);
                    vm.groupsTimeLine.forEach(function () {
                        vm.groupsTimeLine.update({
                            'id': vm.groups[group],
                            visible: vm.checkedAll
                        });
                    });
                }

            }
        }

        function isEventGroup(groupName) {
            if (vm.eventGroupSet.has(groupName)) {
                return true;
            }
            return false;
        }

        function addVisItem(visItem) {
            vm.items.add(visItem);
        }

        function updateVisItem(visItem) {
            vm.items.update(visItem);
        }
        function setValidityPeriod() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-restrict-period.html',
                controller: 'PlanningRestrictPeriodController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning
                }
            }).result.then(function () {
            }, function () {
            });
        }
        function canUpdateObsDef() {
            return vm.planning.observationDefinitions.label !== vm.selectedNewObservationDefinitions
                && vm.selectedNewObservationDefinitions;
        }

        function canUpdateParent() {
            return vm.planning.parentLabel !== vm.selectedNewParentLabel && vm.selectedNewParentLabel;
        }

        function canUpdateEvents() {
            return vm.planning.eventCollections.label !== vm.selectedNewEventCollections && vm.selectedNewEventCollections;
        }

        function search(text) {
            var occurrences = vm.items.get({
                filter: function (item) {
                    return (item.occurrence.name.indexOf(text) >= 0);
                }
            });
            var ids = [];
            for (var i = 0; i < occurrences.length; i++) {
                ids.push(occurrences[i].id);
            }

            vm.timeline.setSelection(ids, {
                focus: true
            })
        }

        function resetWidth() {
            if (vm.isMaster) {
                setPickerDate(vm.planning.eventCollections.validityStartTime.substring(0, 10));
                setPickerDate2(vm.planning.eventCollections.validityEndTime.substring(0, 10));
            } else {
                setPickerDate(vm.planning.validityStartTime.substring(0, 10));
                setPickerDate2(vm.planning.validityEndTime.substring(0, 10));
            }
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);

            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
            vm.timeline.setWindow(vm.getPickerDate(), vm.getPickerDate2(), {
                animation: true
            });
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }

        function resetZoomedDates() {
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }
        function getPickerDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.picker.date);
            } else {
                return vm.picker.date;
            }
        }
        function goBack() {
            $state.go(previousState.name, previousState.params);
        }
        function getPickerDate2() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.picker2.date);
            } else {
                return vm.picker2.date;
            }
        }
        function getPickerPoint1() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.pickerPoint1.date);
            } else {
                return vm.pickerPoint1.date;
            }
        }

        function getPickerPoint2() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.pickerPoint2.date);
            } else {
                return vm.pickerPoint2.date;
            }
        }

        function reload() {
            resetZoomedDates();
            resetScroll();
            location.reload();
        }


        function resetScroll() {
            $cookies.put(getCookiePrefix() + "latestYOffset", 0);
        }

        function updateParent() {
            Planning.updateParent(
                {
                    planType: PlanTypes['child'],
                    planLabel: vm.planning.label,
                    parentLabel: vm.selectedNewParentLabel
                },
                function successCallback() {
                    vm.changeParentVisible = false;
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )
        }
        function zoomIn() {
            vm.timeline.zoomIn(0.2);
        }
        function zoomOut() {
            vm.timeline.zoomOut(0.2);
        }
        function movePlanLeft() {
            movePlan(true);
        }

        function movePlanRight() {
            movePlan(false);
        }

        function movePlan(moveBackwards) {
            var windowTime = vm.timeline.getWindow();
            var millisTotalShown = windowTime.end.getTime() - windowTime.start.getTime();
            var millisCentralDate = windowTime.start.getTime() + millisTotalShown / 2;

            var newMillisCentralDate;
            if (moveBackwards) {
                newMillisCentralDate = millisCentralDate - millisTotalShown / 10;
            } else {
                newMillisCentralDate = millisCentralDate + millisTotalShown / 10;
            }

            vm.timeline.moveTo(new Date(newMillisCentralDate));
        }
        function setPickerDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.picker.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
                vm.pickerPoint1.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
            } else {
                vm.picker.date = date;
                vm.pickerPoint1.date = date;
            }
        }

        function setPickerDate2(date) {
            if (vm.isTimelineWithNoDates) {
                vm.picker2.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
                vm.pickerPoint2.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
            } else {
                vm.picker2.date = date;
                vm.pickerPoint2.date = date;
            }
        }
        function createTimeLine(updatedPlanning, newOccurrence, checkedValue) {
            var container = document.getElementById('visualization');

            if (updatedPlanning != null) {
                vm.planning = updatedPlanning;
            }
            if (checkedValue != null) {
                vm.checkedValue = checkedValue;
            }

            var eventsSet = new Set();
            var happenings = [];
            if (!vm.isTimelineWithNoDates) {
                happenings = vm.planning.eventsTimeline.happenings;
            }
            happenings = happenings.concat(vm.planning.observationInstanceTimeline.happenings);
            if (vm.planning.hasOwnProperty('soopInstanceTimeline')) {
                happenings = happenings.concat(vm.planning.soopInstanceTimeline.happenings);
            }
            var timeLineOccurrences = [];
            var groupsList = [];
            for (var i = 0; i < happenings.length; i++) {
                var occurrence = happenings[i];
                if (occurrence.hasOwnProperty('visible') && occurrence.visible === false) {
                    continue;
                }

                var group = null;
                var isEvent = occurrence.type === 'event';
                var isObservation = occurrence.type === 'observation';
                var isSoop = occurrence.type === 'soop';
                if (isEvent) {
                    group = occurrence.group.groupName;
                    if (eventsSet.has(group) === false) {
                        eventsSet.add(group);
                    }
                } else if (isObservation) {
                    group = occurrence.experiment;
                } else if (isSoop) {
                    group = soopsGroup;
                }

                var style = 'background-color: ' + occurrence.colour + ';';
                style += 'border-color: ' + occurrence.colour + ';';
                var start = occurrence.startDate;
                var end = occurrence.endDate;
                var startString = start;
                var endString = end;
                if (vm.isTimelineWithNoDates) {
                    startString = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, start);
                    endString = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, end);
                } else {
                    startString += ' (' + SoopkitchenUtils.getDayOfYear(occurrence.startDate) + ')';
                    endString += ' (' + SoopkitchenUtils.getDayOfYear(occurrence.endDate) + ')';
                }
                var name = occurrence.name;

                var content = "<span id='timelineOccurrence_" + i + "' style ='" + style + "'>" + name;
                var title = content;
                if (isEvent && occurrence.description) {
                    title += ' (' + occurrence.description + ')'
                }
                if (isSoop) {
                    title += ' (' + occurrence.encodedSoopType + '_' + occurrence.soopInstanceId + ')'
                }
                title += "</span>";
                if (start === end) {
                    title += '<br>' + startString + '<br>';
                    style += "width:10px; \
                    height: 10px;\
                    border: 2px solid\
                    -webkit-transform: rotate(45deg) skew(15deg, 15deg);\
                    -moz-transform: rotate(45deg) skew(15deg, 15deg);\
                    -ms-transform: rotate(45deg) skew(15deg, 15deg);\
                    -o-transform: rotate(45deg) skew(15deg, 15deg);\
                    transform: rotate(45deg) skew(15deg, 15deg);";
                    content = "<span id='timelineOccurrence_" + i + "' style ='visibility: hidden;'>" + name + " </span>";
                } else {
                    title += '<br>' + startString + '->' + endString + '<br>';
                }
                // SPKT-1051: Show SOOP instance volume in the GUI
                if (isSoop) {
                    title += ' Soop Instance Volume = ' + SoopkitchenUtils.roundDecimals(occurrence.soopInstanceVolume, 1) + ' MiB<br>';
                }

                var module = "";
                var subgroup = "";
                var def;
                if (isObservation) {
                    module = occurrence.module;
                    title += "Module: " + module + '<br>';
                    title += "SOC OBS_IDs: " + occurrence.ids + '<br>';
                    // to group by module
                    subgroup = module;
                    def = vm.observationsPerInstrument[occurrence.experiment].allObservations[occurrence.module][occurrence.name];
                } else if (isEvent) {
                    if (occurrence.group.subgroupName) {
                        subgroup = occurrence.group.subgroupName;
                    } else {
                        subgroup = occurrence.originalName;
                    }
                } else if (isSoop) {
                    subgroup = occurrence.soopType;
                }

                if (isEvent) {
                    if (occurrence.hasOwnProperty('count') && occurrence.count) {
                        title += 'count: ' + occurrence.count + '<br>';
                    }
                    if( Object.keys(occurrence.parameters).length > 0) {
                        for (var parameter in occurrence.parameters) {
                            if (occurrence.parameters.hasOwnProperty(parameter)) {
                                title += parameter + ": " + occurrence.parameters[parameter] + '<br>';
                            }
                        }
                    }
                } else {
                    if (occurrence.hasOwnProperty('numberParameters')) {
                        for (var numberParameter in occurrence.numberParameters) {
                            if (occurrence.numberParameters.hasOwnProperty(numberParameter)) {
                                title += numberParameter + ": " + occurrence.numberParameters[numberParameter];
                                if (def.numberParameters[numberParameter].unit != null) {
                                    title += " " + def.numberParameters[numberParameter].unit;
                                }
                                title += '<br>';
                            }
                        }
                    }
                    if (occurrence.hasOwnProperty('listParameters')) {
                        for (var listParameter in occurrence.listParameters) {
                            if (occurrence.listParameters.hasOwnProperty(listParameter)) {
                                title += listParameter + ": " + occurrence.listParameters[listParameter];
                                if (def.listParameters[listParameter].unit != null) {
                                    title += " " + def.listParameters[listParameter].unit;
                                }
                                title += '<br>';
                            }
                        }
                    }
                }
                if (occurrence.hasOwnProperty('flush') && occurrence.flush != null && occurrence.flush !== 0) {
                    title += "FLUSH: " + occurrence.flush;
                    if (def.flush.unit != null) {
                        title += " " + def.flush.unit;
                    }
                    title += " (" + def.flush.flushType + ")<br>";
                }
                if (occurrence.hasOwnProperty('power') && occurrence.power != null && occurrence.power !== 0) {
                    title += "POWER: " + occurrence.power;
                    if (def.power.unit != null) {
                        title += " " + def.power.unit;
                    }

                    title += "<br>";
                }

                var flowsSet = new Set();
                if (occurrence.hasOwnProperty('flows') && occurrence.flows != null) {
                    for (var flowName in occurrence.flows) {
                        if (occurrence.flows.hasOwnProperty(flowName)) {
                            flowsSet.add(flowName);
                            title += flowName + "(" + def.flows[flowName].flowType + "): ";
                            title += SoopkitchenUtils.roundDecimals(occurrence.flows[flowName], 2);
                            if (def.flows[flowName].unit != null) {
                                title += " " + def.flows[flowName].unit;
                            }
                            title += " | " + SoopkitchenUtils.roundDecimals(occurrence.volumes[flowName], 3) + " Mibytes <br>"
                        }
                    }
                }
                if (occurrence.volumes) {
                    var totalDays = (SoopkitchenUtils.dateToSeconds(end) - SoopkitchenUtils.dateToSeconds(start)) / 86400;

                    for (var volume in occurrence.volumes) {
                        if (occurrence.volumes.hasOwnProperty(volume)) {
                            title += volume + ": " + SoopkitchenUtils.roundDecimals(occurrence.volumes[volume], 3) + ' Mibytes';
                            if (volume.includes('_TAV')) {
                                var volumePerDay = occurrence.volumes[volume] / totalDays;
                                title += ' | ' + SoopkitchenUtils.roundDecimals(volumePerDay, 3) + ' Mibytes/Day';
                            }
                            title += '<br>';
                        }
                    }
                }
                if (occurrence.comment) {
                    title = title + "Comment = " + occurrence.comment + ' <br>';
                    //title = title + "Comment = " + occurrence.comment.replace(/\n/g, '<br>') + ' <br>';
                }

                var occurrenceObj = {
                    id: (i + 1),
                    occurrence: occurrence,
                    subgroup: subgroup,
                    module: module,
                    title: title,
                    content: content,
                    start: start,
                    group: group,
                    style: style
                };

                if (start !== end) {
                    occurrenceObj.end = end;
                } else {
                    occurrenceObj.className = 'instantaneous';
                }

                timeLineOccurrences.push(occurrenceObj);
            }

            vm.eventGroupSet = eventsSet;
            vm.groups = createGroups(eventsSet, groupsList, checkedValue != null);
            container.innerHTML = "";

            var groups = new vis.DataSet(groupsList);
            groups.forEach(function (group) {
                vm.checkedValue[group.id] = false === ($cookies.get(getCookiePrefix() + "checkbox_" + group.id) === "false");
                groups.update({
                    'id': group.id,
                    visible: false === ($cookies.get(getCookiePrefix() + "checkbox_" + group.id) === "false")

                });
            });
            vm.groupsTimeLine = groups;
            vm.items = new vis.DataSet(timeLineOccurrences);
            var newOccurrenceItemList = null;
            if (newOccurrence != null) {
                newOccurrenceItemList = vm.items.get({
                    filter: function (item) {
                        return (item.occurrence.startDate === newOccurrence.startDate
                            && item.occurrence.endDate === newOccurrence.endDate && item.occurrence.name
                                .startsWith(newOccurrence.name));
                    }
                });
            }
            if (($cookies.get(getCookiePrefix() + "earliestZoomedDate") != null) && $cookies.get(getCookiePrefix() + "latestZoomedDate")) {
                vm.options.start = $cookies.get(getCookiePrefix() + "earliestZoomedDate");
                vm.options.end = $cookies.get(getCookiePrefix() + "latestZoomedDate");
                setPickerDate(vm.options.start.substring(0,10));
                setPickerDate2(vm.options.end.substring(0,10));
            } else {
                vm.options.start = vm.getPickerDate();
                vm.options.end = vm.getPickerDate2();
            }

            vm.updateDuration();
            vm.selection = [];
            vm.timeline = new vis.Timeline(container, vm.items, groups, vm.options);

            vm.timeline.on('select', function (properties) {
                vm.selected = properties.items.length;
                vm.selection = [];
                vm.isSoopSelected = false;
                if (properties.items.length === 1) {
                    var occurrences = vm.items.get({
                        filter: function (item) {
                            return (item.id === properties.items[0]);
                        }
                    });
                    var soopObservations = extractSelection(occurrences[0]);
                    var soopOccurrenceId = -1;
                    soopObservations.forEach(function (soopObs) {
                        vm.selection.push(soopObs.id);
                        if (soopObs.occurrence.hasOwnProperty('soopInstanceId')) {
                            soopOccurrenceId = soopObs.id;
                        }
                    });
                    if (soopOccurrenceId > -1) {
                        vm.isSoopSelected = true;
                        vm.timeline.setSelection(vm.selection);
                        setIconsToSpoons(document.getElementsByClassName("vis-delete"));
                        vm.timeline.focus(soopOccurrenceId);
                    } else {
                        setIconsToPencils(document.getElementsByClassName("vis-delete"));
                    }
                } else {
                    setIconsToPencils(document.getElementsByClassName("vis-delete"));
                }
            });

            vm.timeline.on('contextmenu', function (props) {
                if (vm.isVersion) {
                    return;
                }
                if (props.what === 'background' || props.what === 'item') {
                    props.event.preventDefault();
                    vm.openContextMenu(props);
                } else {
                    vm.closeContextMenu();
                }
            });
            vm.timeline.on('rangechanged', function (props) {
                $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(props.start));
                $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(props.end));
                if (vm.isSoopSelected && vm.selection.length > 1) {
                    vm.timeline.setSelection(vm.selection);
                    setIconsToSpoons(document.getElementsByClassName("vis-delete"));
                } else {
                    setIconsToPencils(document.getElementsByClassName("vis-delete"));
                }
            });

            if (newOccurrenceItemList != null) {
                vm.timeline.setSelection([newOccurrenceItemList[0].id], {
                    focus: true
                })
            }

            vm.groupChange = function groupChange(group) {
                $cookies.put(getCookiePrefix() + "checkbox_" + group, false === vm.checkedValue[group]);
                vm.checkedValue[group] = (false === vm.checkedValue[group]);
                groups.forEach(function () {
                    groups.update({
                        'id': group,
                        visible: vm.checkedValue[group]
                    });
                });

            };

            // Back to previous scroll position... and reset!
            if ($cookies.get(getCookiePrefix() + "latestYOffset") != null) {
                $window.scrollTo(0, $cookies.get(getCookiePrefix() + "latestYOffset"));
                resetScroll();
            }
        }
        function createGroups(eventsSet, groupsList, alreadySelectedGroups) {
            var instruments = REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS);
            var events = Array.from(eventsSet);

            var groups = events;
            if (vm.hasSoops) {
                groups.push(soopsGroup);
            }
            groups = groups.concat(instruments);
            var instSet = new Set(IN_SITU_INSTRUMENTS);
            var remoteSet = new Set(REMOTE_SENSING_INSTRUMENTS);
            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var style = "";
                if (instSet.has(group)) {
                    style = "background-color: #C0C0C0"
                } else if (remoteSet.has(group)) {
                    style = "background-color: #DCDCDC;"
                } else if (eventsSet.has(group)) {
                    style = "background-color: #F5F5F5;"
                }
                groupsList.push({
                    id: group,
                    value: group,
                    'content': '<span id="group_' + group + '">' + group + '</span>',
                    'style': style,
                    orderId: i

                });

                if (alreadySelectedGroups === false || vm.checkedValue[group] == null) {
                    vm.checkedValue[group] = true;
                }
            }
            return groups;
        }
        function extractSelection(occurrenceSelected) {
            var soopObservations = [];
            if (occurrenceSelected.occurrence.type === 'soop') {
                soopObservations.push(occurrenceSelected);
                soopObservations = soopObservations.concat(vm.items.get({
                    filter: function (item) {
                        if (item.occurrence.hasOwnProperty('compositeId')) {
                            return belongsToSoop(item, occurrenceSelected);
                        }
                        return false;
                    }
                }));
            } else {
                soopObservations.push(occurrenceSelected);
            }

            return soopObservations;
        }


        function belongsToSoop(item, occurrenceSelected) {
            var compositeSoopIds = item.occurrence.compositeId.compositeSoopIds;
            for (var i = 0; i < compositeSoopIds.length; i++) {
                if (compositeSoopIds[i].soopInstanceId === occurrenceSelected.occurrence.soopInstanceId
                    && compositeSoopIds[i].encodedSoopType === occurrenceSelected.occurrence.encodedSoopType
                ) {
                    return true;
                }
            }
            return false;
        }
        function setIconsToPencils (icons) {
            for (var i = 0; i < icons.length; i++) {
                if (icons[i] !== undefined) {
                    icons[i].style ="content:url('content/images/edit.png')";
                    icons[i].title ="Update occurrence";
                }
            }
        }
        function setIconsToSpoons (icons) {
            if (icons.length>1) {
                var soopOccurrence = icons[0];
                soopOccurrence.style = "content:url('content/images/edit.png')";
                soopOccurrence.title = "Update SOOP";
                for (var i = 1; i < icons.length; i++) {
                    if (icons[i] !== undefined) {
                        icons[i].style ="content:url('content/images/spoon.png')";
                        icons[i].title ="Update SOOP component";
                    }
                }
            }
        }
    }

})();
